import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "configs/store";
import {
  fetchCourses,
  fetchCourse,
  createCourse,
  updateCourse,
  deleteCourse,
  enrollCourse,
  fetchMyEnrollments,
  Course,
  clearError,
} from "slices/courseSlice";
import { useContext } from "react";
import { AppContext } from "context/appContext";
import { UUID } from "crypto";
import { courseApi } from "configs/api";

export const useCourse = () => {
  const dispatch = useDispatch();
  const { showAlert } = useContext(AppContext);
  const { courses, enrollments, currentCourse, loading, error, pagination } = useSelector(
    (state: RootState) => state.courses
  );

  useEffect(() => {
    if (error) {
      showAlert(error, "error", "Error");
      dispatch(clearError());
    }
  }, [error, showAlert, dispatch]);

  const getAllCourses = useCallback(
    (page = 1, limit = 10, instructorID?: string, status?: string, visibility?: string, companyID?: string, branchID?: string) => {
      dispatch(fetchCourses({ page, limit, instructorID, status, visibility, companyID, branchID }) as any);
    },
    [dispatch]
  );

  const getCourse = useCallback(async (id: string) => {
    const courseData = await courseApi.get(`/api/courses/${id}`);
    console.log("Fetched course data:", courseData);
    return courseData.data;
  }, []);

  const addCourse = useCallback(
    async (courseData: Partial<Course>) => {
      try {
        const result = await dispatch(createCourse(courseData) as any);
        if (createCourse.fulfilled.match(result)) {
          showAlert("Course created successfully!", "success", "Success");
          return {
            status: true,
            data: result.payload.data,
          };
        }
        return {
          status: false,
          error: result.error.message || "Failed to create course",
        };
      } catch (err: Error | any) {
        return {
          status: false,
          error: err.message || "Failed to create course",
        };
      }
    },
    [dispatch, showAlert]
  );

  const editCourse = async ( id: string, data: Partial<Course> ) => {
    try {
      const response = await courseApi.put(`/api/courses/${id}`, data);
      return {
        status: true,
        data: response.data,
      };
    } catch (err: Error | any) {
      return {
        status: false,
        error: err.message || "Failed to create course",
      };
    }
  };
  // useCallback(
  //   async (id: string, courseData: Partial<Course>) => {
  //     try {
  //       const result = await dispatch(updateCourse({ id, data: courseData }) as any);
  //       console.log("sucess 2", result);
  //       if (updateCourse.fulfilled.match(result)) {
  //         console.log("sucess 3");
  //         showAlert("Course updated successfully!", "success", "Success");
  //         return {
  //           status: true,
  //           data: result.payload.data,
  //         };
  //       }
  //       console.log("fail 1");
  //       return {
  //         status: false,
  //         error: result.error.message || "Failed to create course",
  //       };
  //     } catch (err: Error | any) {
  //       console.log("fail 2");
  //       return {
  //         status: false,
  //         error: err.message || "Failed to create course",
  //       };
  //     }
  //   },
  //   [dispatch, showAlert]
  // );

  const removeCourse = useCallback(
    async (id: string) => {
      try {
        const result = await dispatch(deleteCourse(id) as any);
        if (deleteCourse.fulfilled.match(result)) {
          showAlert("Course deleted successfully!", "success", "Success");
          return true;
        }
        return false;
      } catch (err) {
        return false;
      }
    },
    [dispatch, showAlert]
  );

  const enrollInCourse = useCallback(
    async (courseId: string) => {
      try {
        const result = await dispatch(enrollCourse(courseId) as any);
        if (enrollCourse.fulfilled.match(result)) {
          showAlert("Successfully enrolled in course!", "success", "Success");
          return result.payload.data;
        }
        return null;
      } catch (err) {
        return null;
      }
    },
    [dispatch, showAlert]
  );

  const getMyEnrollments = useCallback((filters?: { companyID?: string; branchID?: string; employeeID?: string }) => {
    dispatch(fetchMyEnrollments(filters) as any);
  }, [dispatch]);

  return {
    courses,
    enrollments,
    currentCourse,
    loading,
    error,
    pagination,
    getAllCourses,
    getCourse,
    addCourse,
    editCourse,
    removeCourse,
    enrollInCourse,
    getMyEnrollments,
  };
};
